import React, { useEffect } from 'react';
import { isMenuCollapsed } from '@apollo-internal/cache';

/**
 * @typedef {object} LandingPageWrapperProps
 * @property {React.ElementType} page
 */

/**
 * @param {LandingPageWrapperProps} props
 */
const LandingPageWrapper = props => {
  const Page = props.page;

  useEffect(() => {
    isMenuCollapsed(false);
  }, []);

  return <Page />;
};

export default LandingPageWrapper;
